import { z } from 'zod';
import { partnerCockpitMembershipStatusSchema, partnerCockpitRoleSchema } from './user.js';
export const impersonatePartnerCockpitUserSchema = z.object({
    partnerId: z.number().int().positive(),
    cockpitUserUuid: z.uuid(),
});
export const opsPartnerCockpitUserSchema = z.object({
    cockpitUserUuid: z.uuid(),
    email: z.email(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    role: partnerCockpitRoleSchema,
    status: partnerCockpitMembershipStatusSchema,
});
export const startCockpitImpersonationResponseSchema = z.object({
    url: z.url(),
});
